import { dispatch } from './events';
import { DISPATCH_PAYWALL_EVENT } from '../components/FeatureWall/constants';

export function openPayWall(details) {
  dispatch(DISPATCH_PAYWALL_EVENT, { ...details, isPayWall: true });
}

export function openFeatureWall(details) {
  dispatch(DISPATCH_PAYWALL_EVENT, { ...details, isPayWall: false });
}
